export default "__VITE_ASSET__gv5z6h6z__"